import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { Role as RoleConfig } from '../../../shared/configs/roles.config';
import { CommonService } from '../../services/http/common/common.service';
import { MasterListType } from '../../services/http/ple/assessments/assessment.service';
import { MaintenanceService } from '../../services/maintenance/maintenance.service';
import { UserDetailsService } from '../../services/user-details/user-details.service';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-maintenance',
  templateUrl: './maintenance.component.html',
  styleUrls: ['./maintenance.component.scss'],
})
export class MaintenanceComponent implements OnInit, OnDestroy {
  maintenanceMessage: string = '';

  private destroy$ = new Subject<void>();
  role: typeof RoleConfig = RoleConfig;
  canAccessMaintenancePage: boolean = false;

  constructor(
    private maintenanceService: MaintenanceService,
    private commonService: CommonService,
    private router: Router,
    private userDetailsService: UserDetailsService,
  ) {}

  ngOnInit(): void {
    this.maintenanceMessage = this.maintenanceService.currentMaintenanceMessage;

    const userTypes = this.userDetailsService.userDetails?.roles;

    const userRole = userTypes?.find((role) => role.name === this.role.superAdmin);
    if (userRole) {
      this.canAccessMaintenancePage = true;
    }

    this.commonService
      .fetchMasterLists([MasterListType.analyticsMenu])
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.maintenanceService.isMaintenanceMode
          .pipe(takeUntil(this.destroy$))
          .subscribe((isMaintenanceMode) => {
            if (!isMaintenanceMode) {
              this.router.navigate(['/quest/home']);
            }
          });
      });

    this.maintenanceService.maintenanceMessage
      .pipe(takeUntil(this.destroy$))
      .subscribe((message) => {
        this.maintenanceMessage =
          message || 'We will be back online shortly. Thank you for your patience.';
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
